<template>
    <v-row class="ma-0">
        <v-col class="pa-0 pb-4">
            <v-card elevation="1" class="background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Controllo Numerazione</p>
                </v-card-title>
                <v-divider></v-divider>
                <v-container class="pa-0 pb-4" fluid>
                    <v-row class="pa-4">
                        <v-col class="pt-4 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-switch
                                :label="switchLabel"
                                v-model="settings['enable_numbering_check']"
                                color="primary"
                                inset
                                hide-details
                                class="margin-auto"
                            ></v-switch>
                        </v-col>
                        <v-col class="pt-4 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-switch
                                :label="cronologySwitchLabel"
                                v-model="settings['enable_cronology_check']"
                                color="primary"
                                inset
                                hide-details
                                class="margin-auto"
                            ></v-switch>
                        </v-col>
                    </v-row>

                    <v-row v-if="settings['enable_numbering_check']" class="pa-4 pt-0">
                        <v-col class="pt-4 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-autocomplete
                                v-model="settings['numbering_check_sectionals']"
                                :items="sectionals"
                                item-text="name"
                                item-value="id"
                                label="Sezionali da controllare (opzionale)"
                                hint="Lascia vuoto per controllare TUTTI i sezionali (inclusi quelli futuri)"
                                persistent-hint
                                multiple
                                chips
                                small-chips
                                deletable-chips
                                clearable
                                outlined
                                dense
                            >
                                <template v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title class="text-body-2 font-weight-medium">
                                                <v-icon small class="mr-2" color="info">mdi-information</v-icon>
                                                Se non selezioni nessun sezionale, il controllo sarà attivo per TUTTI i sezionali esistenti e futuri
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-container>
                <v-divider></v-divider>
                <v-card-actions class="pr-4">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'

export default {
    name: 'numbering-check-settings',
    mixins: [SettingsOptionsMixin],
    props: {
        modelName: {
            type: String,
            required: true
        },
        documentLabel: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            model: this.modelName,
            settings: {
                'enable_numbering_check': false,
                'enable_cronology_check': false,
                'numbering_check_sectionals': []
            },
            sectionals: []
        }
    },

    computed: {
        switchLabel() {
            return `Abilita controllo numerazione per ${this.documentLabel}`
        },
        cronologySwitchLabel() {
            return `Abilita controllo cronologia numerazione per ${this.documentLabel}`
        }
    },

    created() {
        this.fetchSectionals()
    },

    methods: {
        async fetchSectionals() {
            try {
                const response = await this.$http.post('/sectionals-filters', {
                    page: 1,
                    per_page: 1000,
                    sortBy: [],
                    sortDesc: [false],
                    advancedFilters: {},
                    filter: ''
                })

                if (response && response.data && response.data.data && Array.isArray(response.data.data.data)) {
                    this.sectionals = response.data.data.data.map(s => ({
                        id: s.id,
                        name: s.name
                    }))
                }
            } catch (error) {
                console.error('Error fetching sectionals:', error)
            }
        }
    }
}
</script>
